var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4109 11.345L15.6209 14.555L14.5559 15.62L11.3459 12.41C10.7559 12.88 10.1109 13.24 9.41086 13.49C8.67086 13.75 7.91086 13.88 7.13086 13.88C5.91086 13.88 4.77586 13.575 3.72586 12.965C2.70586 12.365 1.90086 11.555 1.31086 10.535C0.690859 9.485 0.380859 8.35 0.380859 7.13C0.380859 5.91 0.690859 4.775 1.31086 3.725C1.90086 2.705 2.70586 1.9 3.72586 1.31C4.77586 0.689996 5.91086 0.379995 7.13086 0.379995C8.35086 0.379995 9.48586 0.689996 10.5359 1.31C11.5559 1.9 12.3659 2.705 12.9659 3.725C13.5759 4.775 13.8809 5.91 13.8809 7.13C13.8809 7.91 13.7509 8.67 13.4909 9.41C13.2409 10.11 12.8809 10.755 12.4109 11.345ZM10.8959 10.79C11.3659 10.31 11.7309 9.76 11.9909 9.14C12.2509 8.5 12.3809 7.83 12.3809 7.13C12.3809 6.18 12.1409 5.295 11.6609 4.475C11.2009 3.685 10.5759 3.06 9.78586 2.6C8.96586 2.12 8.08086 1.88 7.13086 1.88C6.18086 1.88 5.29586 2.12 4.47586 2.6C3.68586 3.06 3.06086 3.685 2.60086 4.475C2.12086 5.295 1.88086 6.18 1.88086 7.13C1.88086 8.08 2.12086 8.965 2.60086 9.785C3.06086 10.575 3.68586 11.2 4.47586 11.66C5.29586 12.14 6.18086 12.38 7.13086 12.38C7.83086 12.38 8.50086 12.25 9.14086 11.99C9.76086 11.73 10.3109 11.365 10.7909 10.895L10.8959 10.79Z",
    fill: "#8486A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fe7d67f26ba994633d76d918e4acad56.svg";
export { ForwardRef as ReactComponent };